import { CrudModel } from './_crud';

export class SpecialtyModel extends CrudModel {
  constructor() {
    super('public/specialty');
  }
}

export default new SpecialtyModel();
